import React, { useContext } from "react";
import HeroSection from "../components/HeroSection";
import SectorGrid from "../components/SectorGrid";
import CTASection from "../components/CTASection";
import PartnersSection from "../components/PartnersSection";
import HealthyColaCallout from "../components/HealthyColaCallout";
import Founders from "../components/Founders";
import Timeline from "../components/Timeline";
import Certifications from "../components/Certifications";
import TrustedBy from "../components/TrustedBy";
import Testimonials from "../components/Testimonials";
import FootprintMap from "../components/FootprintMap";
import Seo, { buildOrganizationJsonLd, buildLocalBusinessJsonLd } from "../components/Seo";
import { ContentContext } from "../contexts/ContentContext";

export default function HomePage() {
    const { data } = useContext(ContentContext);

    const jsonLd = {
        "@context": "https://schema.org",
        "@graph": [
            buildOrganizationJsonLd(data),
            buildLocalBusinessJsonLd(data),
        ],
    };

    return (
        <>
            <Seo
                title={null}
                description={data.meta?.siteDescription}
                path="/"
                jsonLd={jsonLd}
            />

            <HeroSection />

            <TrustedBy />

            <section className="relative py-20 md:py-28 bg-white overflow-hidden">
                <div className="absolute -bottom-10 -left-10 w-72 h-72 brand-pattern opacity-50 pointer-events-none" />
                <div className="relative max-w-6xl mx-auto px-6 lg:px-8 grid lg:grid-cols-5 gap-12 items-center">
                    <div className="lg:col-span-2">
                        <div className="inline-flex items-center gap-3 mb-4">
                            <span className="h-px w-10 bg-gold-500" />
                            <span className="text-xs font-bold text-brand-emerald tracking-[0.22em] uppercase">
                                {data.intro.eyebrow}
                            </span>
                        </div>
                        <h2 className="font-serif text-3xl md:text-5xl font-bold text-navy-900 leading-tight">
                            {data.intro.title}
                        </h2>
                    </div>
                    <div className="lg:col-span-3">
                        <p className="text-lg text-navy-700/85 leading-relaxed">
                            {data.intro.body}
                        </p>
                        <div className="mt-6 flex flex-wrap items-center gap-3 text-xs uppercase tracking-[0.2em] font-semibold text-brand-emerald">
                            {(data.about?.values?.items || []).map((v, i) => (
                                <span key={i} className="inline-flex items-center gap-2">
                                    <span className="h-1.5 w-1.5 rounded-full bg-gold-500" />
                                    {v.title}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <HealthyColaCallout />

            <SectorGrid />

            {/* Operations map */}
            <section className="py-20 md:py-24 bg-white border-t border-navy-100">
                <div className="max-w-7xl mx-auto px-6 lg:px-8">
                    <div className="max-w-2xl mb-10">
                        <div className="inline-flex items-center gap-3 mb-3">
                            <span className="h-px w-10 bg-gold-500" />
                            <span className="text-xs font-bold text-brand-emerald tracking-[0.22em] uppercase">
                                {data.geography.eyebrow}
                            </span>
                        </div>
                        <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy-900 leading-tight">
                            {data.geography.title}
                        </h2>
                    </div>
                    <FootprintMap />
                </div>
            </section>

            <Founders />
            <Timeline />
            <Certifications />
            <Testimonials />
            <PartnersSection />
            <CTASection />
        </>
    );
}
